<template>
  <div class="navigator">
    <div class="desktop">
      <div class="copyright">
        <span class="symbol">&copy;</span>
        <span class="text">JinGraphics</span>
      </div>
      <div class="menu_bar" @mouseleave="moveMenuPointer(previnfo.menu.indicator.id)">
        <span class="menu_item about_us" @click="onClicked('about_us')" @mouseover="moveMenuPointer('about_us')">About Us</span>
        <span class="menu_item services" @click="onClicked('services')" @mouseover="moveMenuPointer('services')">Services</span>
        <span class="menu_item solution" @click="onClicked('solution')" @mouseover="moveMenuPointer('solution')">Solution</span>
        <span class="menu_item contact_us" @click="onClicked('contact_us')" @mouseover="moveMenuPointer('contact_us')">Contact Us</span>
        <span class="menu_pointer"></span>
        <span class="menu_indicator"></span>
      </div>
    </div>
    <div class="mobile">
      <v-btn icon class="menu_botton" @click="lnbopen">
        <v-icon color="#fff" size="16px">mdi-menu</v-icon>
      </v-btn>
      <div class="copyright">
        <span class="symbol">&copy;</span>
        <span class="text">JinGraphics</span>
      </div>
      <div class="overlay" @click="lnbopen"></div>
      <div class="menu_bar" @mouseleave="moveMenuPointer(previnfo.menu.indicator.id)">
        <span class="menu_item about_us" @click="onClicked('about_us')" @mouseover="moveMenuPointer('about_us')">About Us</span>
        <span class="menu_item services" @click="onClicked('services')" @mouseover="moveMenuPointer('services')">Services</span>
        <span class="menu_item solution" @click="onClicked('solution')" @mouseover="moveMenuPointer('solution')">Solution</span>
        <span class="menu_item contact_us" @click="onClicked('contact_us')" @mouseover="moveMenuPointer('contact_us')">Contact Us</span>
        <span class="menu_spacer" @click="lnbopen" @mouseover="moveMenuPointer(previnfo.menu.indicator.id)"></span>
        <span class="menu_pointer"></span>
        <span class="menu_indicator"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    menuinfo: {
      about_us: { label: 'About Us', width: 0, x: 0, height: 0, y: 0 },
      services: { label: 'Services', width: 0, x: 0, height: 0, y: 0 },
      solution: { label: 'Project Visualization', width: 0, x: 0, height: 0, y: 0 },
      contact_us: { label: 'Contact Us', width: 0, x: 0, height: 0, y: 0 },
    },
    previnfo: {
      menu: { 
        indicator: {
          id: 'about_us', 
          width: 0, 
          x: 500, 
          height: 0,
          y: 0,
        },
        pointer: {
          id: 'about_us', 
          width: 0, 
          x: 500, 
          height: 0,
          y: 0,
        }
      },
      mode: null
    },
    setting: false,
    loaded: { desktop: false, mobile: false },
    lnbopened: false,
    mode: 'desktop', // desktop | mobile
  }),
  mounted() {
    window.addEventListener('resize', this.load)

    this.$emit('mounted', 'navigator')
    this.load()
  },
  methods: {
    onClicked(id) {
      this.moveMenuIndicator(id)

      if(this.mode == 'mobile') this.lnbopen()  // close lnb
      this.$emit('menu-action', id)
    },
    load() {
      if(this.setting) return
      this.setting = true

      setTimeout(() => {
        let elbox = document.querySelector('.desktop').getBoundingClientRect()
        if(elbox.width > 0) this.mode = 'desktop'
        else this.mode = 'mobile'

        if(this.loaded[this.mode]) {
          if(this.previnfo.mode && this.previnfo.mode != this.mode) {
            this.moveMenuIndicator(this.previnfo.menu.indicator.id)
            this.moveMenuPointer(this.previnfo.menu.indicator.id)
          }
          this.previnfo.mode = this.mode
          return
        }
        this.loaded[this.mode] = true

        if(this.mode == 'desktop') {
          let xcuml = 0
          Object.keys(this.menuinfo).forEach(k => {
            elbox = document.querySelector(`.desktop .menu_item.${k}`).getBoundingClientRect()
            this.menuinfo[k].width = elbox.width
            this.menuinfo[k].x = xcuml
            xcuml += elbox.width
          })
        } else {
          Object.keys(this.menuinfo).forEach(k => {
            elbox = document.querySelector(`.mobile .menu_item.${k}`).getBoundingClientRect()
            this.menuinfo[k].height = elbox.height
            this.menuinfo[k].y = elbox.top
          })
        }

        this.setNavigatorOpacity(true).then(_ => {
          this.moveMenuIndicator(this.previnfo.menu.indicator.id)
          this.moveMenuPointer(this.previnfo.menu.indicator.id)
        })
        
        this.setting = false
      }, 500)
    },
    moveMenuIndicator(to) {
      this.previnfo.menu.indicator.id = to

      if(this.mode == 'desktop') {
        this.$anime.timeline({loop: false})
        .add({
          targets: `.${this.mode} .menu_indicator`,
          width: [this.previnfo.menu.indicator.width, this.menuinfo[to].width],
          translateX: [this.previnfo.menu.indicator.x, this.menuinfo[to].x],
          easing: "easeOutExpo",
          duration: 500
        })

        this.previnfo.menu.indicator.width = this.menuinfo[to].width
        this.previnfo.menu.indicator.x = this.menuinfo[to].x

      } else {
        this.$anime.timeline({loop: false})
        .add({
          targets: `.${this.mode} .menu_indicator`,
          height: [this.previnfo.menu.indicator.height, this.menuinfo[to].height],
          top: [this.previnfo.menu.indicator.y, this.menuinfo[to].y],
          easing: "easeOutExpo",
          duration: 500
        })

        this.previnfo.menu.indicator.height = this.menuinfo[to].height
        this.previnfo.menu.indicator.y = this.menuinfo[to].y
      }
    },
    moveMenuPointer(to) {
      this.previnfo.menu.pointer.id = to

      if(this.mode == 'desktop') {
        this.$anime.timeline({loop: false})
        .add({
          targets: `.${this.mode} .menu_pointer`,
          translateX: [this.previnfo.menu.pointer.x, this.menuinfo[to].x],
          width: [this.previnfo.menu.pointer.width, this.menuinfo[to].width],
          easing: "easeOutExpo",
          duration: 500
        })

        this.previnfo.menu.pointer.width = this.menuinfo[to].width
        this.previnfo.menu.pointer.x = this.menuinfo[to].x

      } else {
        this.$anime.timeline({loop: false})
        .add({
          targets: `.${this.mode} .menu_pointer`,
          height: [this.previnfo.menu.pointer.height, this.menuinfo[to].height],
          top: [this.previnfo.menu.pointer.y, this.menuinfo[to].y],
          easing: "easeOutExpo",
          duration: 500
        })

        this.previnfo.menu.pointer.height = this.menuinfo[to].height
        this.previnfo.menu.pointer.y = this.menuinfo[to].y
      }
    },
    setNavigatorOpacity(open=true) {
      let el = document.querySelector('.navigator')

      if(open) el.classList.add('loaded')
      else el.classList.remove('loaded')

      return new Promise(resolve => {
        setTimeout(() => { resolve(true) }, 250)
      })
    },
    lnbopen(test) {
      this.lnbopened = !this.lnbopened

      if(this.lnbopened) {
        var transform = [-230, 0]
        var opacity = 1
        document.querySelector('.overlay').style.display = 'block'
      } else {
        transform = [0, -230]
        opacity = 0
        document.querySelector('.overlay').style.display = 'none'
      }

      this.$anime.timeline({loop: false})
      .add({
        targets: '.mobile .menu_bar',
        left: transform,
        opacity: opacity,
        easing: "easeOutExpo",
        duration: 500
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.navigator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;

  color: #fff;
  opacity: 0;

  &.loaded {
    opacity: 1;

    -webkit-transition: opacity .5s ease-out;
       -moz-transition: opacity .5s ease-out;
         -o-transition: opacity .5s ease-out;
            transition: opacity .5s ease-out;
  }

  .desktop, .mobile {
    display: flex;
    justify-content: space-between;
    padding: 10px;

    .copyright {
      display: flex;

      .symbol {
        font-size: 18px;
        display: block;
        padding: 10px;
        padding-right: 1px;
        margin-top: -3px;
      }
      .text {
        display: block;
        padding: 10px;
        padding-left: 1px;
      }
    }
  }

  .desktop {
    display: none;

    .menu_bar {
      position: relative;
      display: flex;

      .menu_item {
        display: block;
        padding: 10px;
      }
      .menu_item:hover {
        cursor: pointer;
      }

      .menu_indicator, .menu_pointer {
        position: absolute;
        display: inline-block;
        height: 3px;
        background-color: #fff;
        opacity: .85;
      }
      .menu_pointer {
        opacity: .25;
      }
    }
  }

  .mobile {
    display: none;

    .menu_botton {
      display: flex;
      justify-content: center;
      align-content: center;
      width: 40px;
      height: 40px;
    }
    .overlay {
      position: absolute;
      top: 0px;
      left: 0px;

      display: none;
      width: 100%;
      height: 100vh;
    }
    .menu_bar {
      position: absolute;
      top: 0px;
      left: -230px;

      display: flex;
      flex-direction: column;

      width: 210px;
      height: 100vh;
      padding: 20px;
      opacity: 0;
      background: rgba(95, 165, 201, 0.975);
      box-shadow: 1px 2px 5px #555;

      .menu_item {
        display: block;
        padding: 10px;
      }
      .menu_item:hover {
        cursor: pointer;
      }

      .menu_spacer {
        display: block;
        width: 100%;
        height: 100%;
      }
      .menu_indicator, .menu_pointer {
        position: absolute;
        left: 10px;

        display: inline-block;
        width: 3px;
        background-color: #fff;
        opacity: .85;
      }
      .menu_pointer {
        opacity: .25;
      }
    }
  }
}
@media screen and (max-width: 550px) {
  .navigator {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }
  }
}
@media screen and (min-width: 550px) {
  .navigator {
    .desktop {
      display: flex;
    }
    .mobile {
      display: none;
    }
  }
}
</style>